/* eslint-disable react/destructuring-assignment */
import { useContext, useMemo } from 'react';
import { getSwapsCustomerSetupConfigFromProps } from '../helpers';
import type { MoonPaySwapsCustomerSetupProps } from '../types';
import { MoonPayContext } from './MoonPayProvider';
import { MoonPayWidget } from './MoonPayWidget';

export function MoonPaySwapsCustomerSetupWidget(
  props: MoonPaySwapsCustomerSetupProps,
) {
  const { apiKey, environment } = useContext(MoonPayContext);

  const config = useMemo(
    () =>
      getSwapsCustomerSetupConfigFromProps({
        props,
        apiKey,
        environment,
        debug: false,
        signature: '',
      }),
    [props, apiKey, environment],
  );

  return (
    <MoonPayWidget
      config={config}
      visible={props.visible}
      onUrlSignatureRequested={props.onUrlSignatureRequested}
      className={props.className}
      style={props.style}
    />
  );
}
